import { DEAL_TYPES } from '../../../../../components-library/carousel/DealsCarousel';
import { PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Discounts',
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Extra Points',
      description: 'Rate us on Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      description: 'Already automatically applied',
    },
    buttons: {
      add: 'Add',
      remove: 'Remove',
    },
  },
  discounts: {
    title: '{{discount}} discount',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} discount off on your next order - code: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]: '{{discount}} discount on your next {{count}} orders - code: {{code}}',
    },
  },
  feedback: {
    login:
      "<highlight>Log in</highlight> to use this promo so we can make sure you haven't used it yet. Login and try again.",
  },
};
